var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"home"},[_c('Navbar'),_c('Header')],1),_c('Contents'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBlank),expression:"showBlank"}],staticClass:"contents"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }